"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControlMessageSerializer = void 0;
const ControlMessage_1 = require("../../../messages/ControlMessage");
const AsciiControlCodes_1 = require("./AsciiControlCodes");
class ControlMessageSerializer {
    serialize(message) {
        const binaryCommands = [
            AsciiControlCodes_1.AsciiControlCodes.DeviceControl1,
            AsciiControlCodes_1.AsciiControlCodes.C_ControlMessage,
            AsciiControlCodes_1.AsciiControlCodes.STX_StartOfText,
            message.type,
            AsciiControlCodes_1.AsciiControlCodes.ETX_EndOfText,
            AsciiControlCodes_1.AsciiControlCodes.EOT_EndOfTransmission
        ];
        return new Uint8Array(binaryCommands);
    }
    deserialize(bytes) {
        const type = bytes[3];
        return new ControlMessage_1.ControlMessage(type);
    }
}
exports.ControlMessageSerializer = ControlMessageSerializer;
//# sourceMappingURL=ControlMessageSerializer.js.map